// ------------------------------------------
// 流れ続ける画像スライダー
// ------------------------------------------
class Marquee {
  constructor(el, opt) {
    this.items = document.querySelectorAll('.' + el);
    if (this.items.length > 0) {
      this.secondsPerItem = 20;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.tracks = Array.from(this.items).map((item) => ({
        wrap: item,
        track: item.querySelector('.js-marquee-track'),
        originals: Array.from(item.querySelector('.js-marquee-track').children),
        x: 0,
        setWidth: 0,
        speed: 0,
        visible: false,
      }));
      this.tick = this.tick.bind(this);
      this.event();
    }
  }

  event() {
    this.build();

    let timer;
    window.addEventListener('resize', () => {
      clearTimeout(timer);
      timer = setTimeout(() => this.build(), 200);
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const s = this.tracks.find((item) => item.wrap === entry.target);
        if (s) s.visible = entry.isIntersecting;
      });
    }, { rootMargin: '100px 0px' });
    this.tracks.forEach((s) => observer.observe(s.wrap));

    requestAnimationFrame(this.tick);
  }

  build() {
    this.tracks.forEach((s) => {
      s.track.querySelectorAll('.is-clone').forEach((clone) => clone.remove());

      const first = s.originals[0];
      const last = s.originals[s.originals.length - 1];
      const gap = parseFloat(getComputedStyle(s.track).columnGap) || 0;
      s.setWidth = last.offsetLeft + last.offsetWidth + gap - first.offsetLeft;
      if (!s.setWidth) return;
      s.speed = this.reduced ? 0 : (s.setWidth / s.originals.length) / this.secondsPerItem;

      const copies = Math.ceil(s.wrap.clientWidth / s.setWidth) + 1;
      for (let i = 0; i < copies; i++) {
        s.originals.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.classList.add('is-clone');
          clone.setAttribute('aria-hidden', 'true');
          s.track.appendChild(clone);
        });
      }
    });
  }

  tick(time) {
    const dt = Math.min(time - (this.last || time), 50) / 1000;
    this.last = time;

    this.tracks.forEach((s) => {
      if (!s.visible || !s.setWidth) return;

      s.x -= s.speed * dt;
      if (s.x <= -s.setWidth) s.x += s.setWidth;
      s.track.style.transform = `translate3d(${s.x}px, 0, 0)`;
    });

    requestAnimationFrame(this.tick);
  }
}
